import * as Yup from 'yup';

export const ContactFormSchema = Yup.object().shape({
  subject: Yup.string().required('Le sujet est requis.'),
  message: Yup.string().required('Le message est requis.').min(50, 'Le message doit avoir au moins 50 caractères.'),
});
